import {PageService, MovieService,PreviewService} from 'hasta-la-vista-middleware-api/service'
import Vue from 'vue'

export default {
    name: 'Promotions',

    data() {
        return {
            loading: true,
            promos: []
        }
    },

    methods: {
        getContent() {
            this.loading = true
            if (this.$breakpoints.xs || this.$breakpoints.sm) {
                Vue.nextTick(() => {
                    if (this.$parent.$el != undefined) window.scroll({
                        top: (this.$parent.$el.offsetTop - 100),
                        left: 0,
                        behavior: 'smooth'
                    })
                })
            }

            Promise.all([PageService.getPromo(), MovieService.getMovies()]).then(([promo,movies])=> {
                this.promos = PreviewService.addPreviewToContentArrayIfAvailable('promotion',promo.data);
                this.promos.forEach((el)=> {
                    if (el.related_movie) {
                        el.movie = movies.findById(el.related_movie)
                    }

                    if (el.mobile_image_listing) {
                        el.srcsets = el.mobile_image_listing + ' 700w, ' + el.image_listing + ' 2000w'
                    } else {
                        el.srcsets = el.image_listing + ' 2000w'
                    }
                });
                this.loading = false
            })
        }
    },

    created(){
        this.getContent()
    },

    mounted() {
        if (window.__PRERENDER_INJECTED) {
            this.loading = false
            this.prerender = true

            if(window.__PRERENDER_INJECTED.promos) {

                this.promos = PreviewService.addPreviewToContentArrayIfAvailable('promotion', window.__PRERENDER_INJECTED.promos)
                this.getAsyncData()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/exclusive-to-sk/promotions/promotions.js